import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import Quill from 'quill';
import Emoji from 'quill-emoji';
import 'quill-emoji/dist/quill-emoji.css';
import { ImageExtend } from 'quill-image-extend-module';
import ImageResize from 'quill-image-resize-vue';


Quill.register('modules/emoji', Emoji);
Quill.register('modules/ImageExtend', ImageExtend);
Quill.register('modules/imageResize', ImageResize);


Vue.use(VueQuillEditor, {
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'image', 'emoji'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': ['', 'center', 'right'] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }, { 'size': [] }]
        ],
        'emoji-toolbar': true,
        'emoji-textarea': false,
        'emoji-shortname': true,
        imageResize: {
            displayStyles: {
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        }
    },
    placeholder: 'Saisissez votre texte formatté ...'
});
